import axios from 'axios';
import { API_url } from '../api.setup';
import { BookingsModel, ServiceOrderModel } from 'src/models/customer/bookingModel';

const API_Controller = '/Bookings';
const BookingService = {
  getAllData: async (cityId, startDate, endDate) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getBookingsForCityByDateRange?cityId=${cityId}&startDate=${startDate}&endDate=${endDate}`
      );
      return response.data as BookingsModel[];
    } catch (error) {
      throw error;
    }
  },

  getServiceOrderById: async (id: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getServiceOrderById?id=${id}`
      );
      return response.data as ServiceOrderModel
    } catch (error) {
      throw error;
    }
  }
}

export default BookingService;
